// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon {\n  float: left;\n  color: rgb(132, 146, 166);\n  font-size: 13px;\n  line-height: 34px;\n  margin-right: 10px;\n}\n.gva-select .el-input__inner {\n  padding: 0 30px !important;\n}", ""]);
// Exports
module.exports = exports;
